import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 989DC863-1210-44A7-88A3-B414994983F6
 * name pan-up
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pan-up.svg
 * tags
 */
export const PanUpIcon = createSvgIcon(<><path d="M12,2.5L8,7H16L12,2.5M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10Z" /></>, 'PanUpIcon');
export default PanUpIcon